import Enum from "../Enum";

export default Enum.create( {
	ACTIVE: "ACTIVE",
	INACTIVE: "INACTIVE",
	HIDDEN: "HIDDEN",
} );
